import PropTypes from 'prop-types';

Containers.propTypes = {
    shipment: PropTypes.shape({
            lineItems: PropTypes.arrayOf(
                PropTypes.shape({
                    wmsItem: PropTypes.shape({
                        places: PropTypes.arrayOf(
                            PropTypes.shape({
                                name: PropTypes.string.isRequired
                            })
                        ).isRequired
                    }).isRequired
                })
            )
        }
    ).isRequired
};


function Containers({shipment, ...props}) {
    const shipmentContainer = shipment.container
    const shipmentLineItems = shipment.lineItems
    const containersNames = shipmentLineItems.map((lineItem) => lineItem.wmsItem?.wmsContainer.name || shipmentContainer.name)
    const uniqueContainers = containersNames.filter((value, index, self) => self.indexOf(value) === index)


    return uniqueContainers.join(', ')
}

export default Containers;
